/* Behaviour of the pages rebuilt from the mockups: gallery, tier picker bound to the
   product's variants, sticky bar, range picker (another product or a colour), add to cart and the cart drawer,
   newsletter, footer accordions, rotating announcement. No dependency. */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var q = new URLSearchParams(location.search);
  if (q.has('tbo')) document.body.classList.add('ev-tbo');

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '$' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ---------- cart drawer ---------- */
  var drawer = $('#ev-cart'), back = $('#evc-back');
  // the free-shipping line follows the shipping rate, which is a weight rule (tiers carry their packed weight)
  var freeGrams = drawer ? +drawer.dataset.freeGrams : 0;
  function openCart() { if (!drawer) return; drawer.classList.add('on'); drawer.setAttribute('aria-hidden', 'false'); back.hidden = false; }
  function closeCart() { if (!drawer) return; drawer.classList.remove('on'); drawer.setAttribute('aria-hidden', 'true'); back.hidden = true; }
  function renderCart(cart) {
    $$('.cart .n').forEach(function (n) { n.textContent = cart.item_count || ''; });
    if (!drawer) return;
    $('#evc-total').textContent = money(cart.total_price);
    var left = freeGrams - cart.total_weight;
    var ds = drawer.dataset;
    $('#evc-free').textContent = !cart.item_count ? ds.msgEmpty : left <= 0 ? ds.msgUnlocked : ds.msgLocked;
    var box = $('#evc-lines');
    if (!cart.items.length) { box.innerHTML = '<p class="evc-empty">' + (drawer.dataset.msgCartEmpty || '') + '</p>'; return; }
    box.innerHTML = cart.items.map(function (it, i) {
      var props = Object.keys(it.properties || {}).filter(function (k) { return k[0] !== '_' && it.properties[k]; })
        .map(function (k) { return k + ': ' + it.properties[k]; }).join(' · ');
      var img = it.image ? '<img src="' + it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="">' : '<span></span>';
      var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      return '<div class="evc-line" data-line="' + (i + 1) + '">' + img +
        '<div><b>' + it.product_title + '</b><span class="v">' + (it.variant_title || '') + '</span>' +
        (props ? '<div class="props">' + props + '</div>' : '') +
        '<div><span class="evc-qty"><button type="button" data-q="' + (it.quantity - 1) + '" aria-label="Less">−</button>' + it.quantity +
        '<button type="button" data-q="' + (it.quantity + 1) + '" aria-label="More">+</button></span>' +
        '<button type="button" class="evc-rm" data-q="0">' + (drawer.dataset.msgRemove || 'Remove') + '</button></div></div>' +
        '<div class="pr">' + money(it.final_line_price) + was + '</div></div>';
    }).join('');
  }
  function refresh() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(renderCart); }
  function add(id, props, btn, extra) {
    if (!id) return;
    if (btn) btn.setAttribute('aria-busy', 'true');
    var body = { items: [{ id: +id, quantity: 1, properties: props || {} }].concat((extra || []).map(function (x) { return { id: +x, quantity: 1 }; })) };
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw r; return refresh(); })
      .then(openCart)
      .catch(function () { location.href = '/cart/add?id=' + id + '&quantity=1'; })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }
  if (drawer) {
    $('.evc-x', drawer).addEventListener('click', closeCart);
    back.addEventListener('click', closeCart);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
    $('#evc-lines').addEventListener('click', function (e) {
      var b = e.target.closest('button[data-q]'); if (!b) return;
      var line = +b.closest('.evc-line').dataset.line;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: +b.dataset.q }) })
        .then(function (r) { return r.json(); }).then(renderCart);
    });
    $$('a.cart').forEach(function (a) {
      if (!$('.n', a)) a.insertAdjacentHTML('beforeend', '<span class="n"></span>');
      a.addEventListener('click', function (e) { e.preventDefault(); refresh().then(openCart); });
    });
    refresh();
  }

  /* ---------- delivery date ---------- */
  $$('.js-date').forEach(function (e) {
    var d = new Date(), n = 0, days = +(e.dataset.days || 7);
    while (n < days) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n++; }
    e.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  });

  /* ---------- product page: gallery ---------- */
  var slides = $$('#gmain .slide'), thumbs = $$('#thumbs button'), cur = 0;
  function show(i) {
    if (!slides.length) return;
    cur = (i + slides.length) % slides.length;
    slides.forEach(function (s, k) { s.classList.toggle('on', k === cur); });
    thumbs.forEach(function (t, k) { t.classList.toggle('on', k === cur); });
    var gi = $('#gidx'); if (gi) gi.textContent = cur + 1;
  }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { show(+t.dataset.i); }); });
  $$('.g-arrow').forEach(function (b) { b.addEventListener('click', function () { show(cur + +b.dataset.dir); }); });

  /* ---------- product page: tiers bound to variants ---------- */
  var tiers = $$('#tiers .tier'), form = $('#ev-buy-form');
  function pick(k) {
    var t = tiers.filter(function (x) { return x.dataset.k == k; })[0]; if (!t) return;
    tiers.forEach(function (x) { x.classList.toggle('sel', x === t); $('input', x).checked = x === t; });
    if (form) form.elements.id.value = t.dataset.variant;
    $$('.js-price').forEach(function (e) { e.textContent = t.dataset.price; });
    $$('.js-name').forEach(function (e) { e.textContent = t.dataset.name; });
    var note = $('#tiernote'); if (note) note.textContent = t.dataset.unl || '';
    $$('#gifts .gift').forEach(function (g) { g.classList.toggle('locked', +k < +g.dataset.need); });
    $$('#seg button').forEach(function (b) { b.classList.toggle('on', b.dataset.k == k); });
    var ao = $('#addon'); if (ao) ao.classList.toggle('off', +k === 3);
  }
  tiers.forEach(function (t) { t.addEventListener('click', function () { pick(t.dataset.k); }); });
  var sel0 = tiers.filter(function (t) { return t.classList.contains('sel'); })[0];
  if (sel0) pick(sel0.dataset.k);
  $$('#seg button').forEach(function (b) { b.addEventListener('click', function () { pick(b.dataset.k); }); });

  var gt = $('.gtoggle');
  if (gt) $('input[type=checkbox]', gt).addEventListener('change', function (e) { gt.classList.toggle('on', e.target.checked); });
  function buyBoxProps() {
    var p = {};
    if (gt && $('input[type=checkbox]', gt).checked) {
      p['Gift'] = 'Yes, no invoice in the box';
      var n = $('.gnote', gt); if (n && n.value.trim()) p['Gift note'] = n.value.trim();
    }
    return p;
  }
  function extras() {
    var ao = $('#addon'), cb = ao && $('input[type=checkbox]', ao);
    return cb && cb.checked && !ao.classList.contains('off') && ao.dataset.variant ? [ao.dataset.variant] : [];
  }
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(form.elements.id.value, buyBoxProps(), $('#buy-cta'), extras()); });
  $$('.js-add').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); if (form) add(form.elements.id.value, buyBoxProps(), b, extras()); }); });
  // mid-page buttons carry their tier into the buy box, then the anchor scrolls
  $$('a[data-tier]').forEach(function (a) { a.addEventListener('click', function () { pick(a.dataset.tier); }); });

  // sticky bar once the buy-box button has scrolled out
  var sticky = $('#sticky'), cta = $('#buy-cta');
  if (sticky && cta) {
    var st = function () { sticky.classList.toggle('on', cta.getBoundingClientRect().bottom < 0); };
    addEventListener('scroll', st, { passive: true }); addEventListener('resize', st); st();
  }

  /* ---------- home: range picker (one label per product or colour, data-variants = its variant ids in tier order) and offer tiers ---------- */
  var cards = $$('#offerTiers .pkc'), choices = $$('#rangeSel label'), choice = choices.filter(function (l) { return l.classList.contains('sel'); })[0] || choices[0];
  var tierIdx = Math.max(0, cards.map(function (c) { return c.classList.contains('sel'); }).indexOf(true));
  function offerVariant() { return choice ? (choice.dataset.variants || '').split(',')[tierIdx] : cards[tierIdx] && cards[tierIdx].dataset.variant; }
  function selTier(i) {
    tierIdx = i;
    cards.forEach(function (x, k) { x.classList.toggle('sel', k === i); });
    var c = cards[i];
    $$('.js-price').forEach(function (p) { p.textContent = c.dataset.price; });
    var u = $('.unl', c), on = $('#offerNote'); if (on) on.textContent = u ? u.textContent : '';
  }
  cards.forEach(function (c, i) {
    c.addEventListener('click', function (e) {
      var b = e.target.closest('.btn');
      if (b) { e.preventDefault(); selTier(i); add(offerVariant(), {}, b); return; }
      selTier(i);
    });
  });
  choices.forEach(function (l) {
    l.addEventListener('click', function () {
      choice = l;
      choices.forEach(function (x) { x.classList.toggle('sel', x === l); });
      $$('#offerTiers .pimg').forEach(function (img) { if (l.dataset.img) { img.src = l.dataset.img; img.removeAttribute('srcset'); } });
    });
  });
  var oc = $('#offer-cta');
  if (oc) oc.addEventListener('click', function (e) { e.preventDefault(); add(offerVariant(), {}, oc); });

  /* ---------- footer and announcement ---------- */
  if (innerWidth >= 768) $$('.fcols details').forEach(function (d) { d.open = true; });
  var ms = $$('#ann .m'), mi = 0;
  if (ms.length > 1) setInterval(function () { if (innerWidth >= 1024) return; ms[mi].classList.remove('on'); mi = (mi + 1) % ms.length; ms[mi].classList.add('on'); }, 4000);
})();
